import React, { useEffect, useState } from 'react';
import { ChangePasswordModal } from './ChangePasswordModal';
import { supabase } from '@/integrations/supabase/client';

interface PasswordChangeGuardProps {
  children: React.ReactNode;
}

export const PasswordChangeGuard: React.FC<PasswordChangeGuardProps> = ({ children }) => {
  const [requiresPasswordChange, setRequiresPasswordChange] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkPasswordChangeRequirement();
  }, []);

  const checkPasswordChangeRequirement = async () => {
    try {
      // Verificar sessionStorage primero
      const sessionRequiresChange = sessionStorage.getItem('require_password_change') === 'true';
      const sessionUserId = sessionStorage.getItem('change_password_user_id');

      if (sessionRequiresChange && sessionUserId) {
        setRequiresPasswordChange(true);
        setUserId(sessionUserId);
        setIsChecking(false);
        return;
      }

      // Verificar en la base de datos
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setIsChecking(false);
        return;
      }

      const { data: profileData } = await supabase
        .from('profiles')
        .select('require_password_change')
        .eq('user_id', user.id)
        .single();

      if (profileData?.require_password_change) {
        setRequiresPasswordChange(true);
        setUserId(user.id);
        sessionStorage.setItem('require_password_change', 'true');
        sessionStorage.setItem('change_password_user_id', user.id);
      } else {
        // Limpiar sessionStorage si ya no requiere cambio
        sessionStorage.removeItem('require_password_change');
        sessionStorage.removeItem('change_password_user_id');
      }

    } catch (error) {
      console.error('Error checking password change requirement:', error);
    } finally {
      setIsChecking(false);
    }
  };

  if (isChecking) {
    return null; // O un loader
  }

  if (requiresPasswordChange && userId) {
    return <ChangePasswordModal isOpen={true} userId={userId} />;
  }

  return <>{children}</>;
};
